import { Component } from "@angular/core";
import { ControlContainer, NgModelGroup, ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MetadataInputTextComponent } from "./metadata-input-text.component";
import { NgClass } from "@angular/common";
import { ClassDirective } from "@ngbracket/ngx-layout/extended";
import { ForgeTextFieldModule } from "@tylertech/forge-angular";
import { FocusOnLoadDirective } from "../../../../directives/focusOnLoad.directive";

@Component({
    selector: "metadata-input-text-area",
    templateUrl: "./metadata-input-textarea.tmpl.html",
    viewProviders: [{ provide: ControlContainer, useExisting: NgModelGroup }],
    imports: [
        ClassDirective,
        FocusOnLoadDirective,
        ForgeTextFieldModule,
        FormsModule,
        NgClass,
        ReactiveFormsModule,
    ],
})
export class MetadataInputTextAreaComponent extends MetadataInputTextComponent
{

    get showLabel(): boolean
    {
        return !this.compact && !this.forCellEdit;
    }
}
